import React, { useEffect, useState } from "react";
import { getImageUrl, formatDate } from "src/Common/common";
import { useNavigate, useParams } from "react-router-dom";
import CustomerService from "src/Services/API/customer.service";
import AccountService from "src/Services/API/account.service";
import { setCustomerName } from "src/Redux/Slices/HeaderSlice";
import { useDispatch } from "react-redux";
import BlueButton from "src/Components/Common/bluebutton";
import AdminAddModal from "./adminaddmodal";
import CustomerInviteService from "src/Services/API/customer.invite.service";
import { toast } from "react-toastify";
import CustomerWO from "./WO/CustomerWo";
import AcceptStatus from "src/Pages/Setting/Team/Invite/Status/acceptstatus";
import PendingStatus from "src/Pages/Setting/Team/Invite/Status/pendingstatus";

const CustomerDetail = () => {
  const navigate = useNavigate();
  const { customerId } = useParams();

  const [customer, setCustomer] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [customerLocations, setCustomerLocations] = useState([]);
  const dispatch = useDispatch();
  const [isAddCustomerAdminModalOpen, setIsAddCustomerAdminModalOpen] = useState(false);

  const [invites, setInvites] = useState([]);

  useEffect(() => {
    console.log("customerId: ", customerId);
    const fetchCustomer = async () => {
      try {
        const [customerResponse, accountsResponse] = await Promise.all([
          CustomerService.getOne(customerId),
          AccountService.getAll(),
        ]);
        const customerData = customerResponse.data;
        const accounts = accountsResponse.data || [];
        const matchedAccount = accounts.find((account) =>
          (account.customers || []).some((accountCustomer) => String(accountCustomer.id) === String(customerId))
        );

        setCustomer(customerData);
        setSelectedAccount(matchedAccount || null);
        setCustomerLocations(matchedAccount?.customers || [customerData]);
        dispatch(setCustomerName(matchedAccount?.name || customerData.companyName));
      } catch (error) {
        console.log("Failed to load customer data: ", error);
      }
    };

    if (customerId) {
      fetchCustomer();
      getAllInvites();
    }
  }, [customerId]);

  const getAllInvites = async () => {
    try {
      const response = await CustomerInviteService.getAll(customerId);
      console.log("🚀 ~ fetchInvites ~ response:", response);
      setInvites(response.data);
    } catch (error) {
      console.log("Failed to load customer invites: ", error);
    }
  };

  const addCustomerAdmin = (data) => {
    CustomerInviteService.create(data)
      .then((res) => {
        console.log("Sending Customer Invite: ", res);
        toast.success("Customer Admin Added Successfully");
        getAllInvites();
      })
      .catch((err) => {
        if (err.response.status === 409) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Something went wrong");
          console.log("Sending Customer Invite Failed: ", err);
        }
      })
      .finally(() => {
        setIsAddCustomerAdminModalOpen(false);
      });
  };

  const onCancelClicked = (index) => {
    CustomerInviteService.deleteInvite(invites[index].id)
      .then((response) => {
        getAllInvites();
        toast("Invite cancelled successfully");
      })
      .catch((error) => {
        toast("An error occured");
      });
  };

  const onRepeatClicked = (index) => {
    CustomerInviteService.repeatInvite(invites[index].id)
      .then((response) => {
        toast("Invite has been sent again successfully");
      })
      .catch((error) => {
        toast("An error occured");
      });
  };

  const getAddedByLabel = (customerData) => {
    return (
      customerData?.addedBy?.name ||
      customerData?.createdBy?.name ||
      customerData?.createdByUser?.name ||
      "-"
    );
  };

  const getBranchSummary = (accountCustomers) => {
    const branchNames = [...new Set(
      accountCustomers
        .map((accountCustomer) => accountCustomer.branch?.name)
        .filter(Boolean)
    )];

    return branchNames.join("/") || "";
  };

  return (
    <div className="w-full h-full px-5 py-3">
      {isAddCustomerAdminModalOpen && (
        <AdminAddModal
          onAddClicked={addCustomerAdmin}
          onCancelClicked={() => {
            setIsAddCustomerAdminModalOpen(false);
          }}
          customer={customer}
        />
      )}
      <div className="w-full h-[56px] flex items-center justify-between ">
        <div className="flex items-center cursor-pointer" onClick={() => navigate(-1)}>
          <img src={getImageUrl("/images/common/back_arrow.png")} className="w-[24px]" />
          <span className="font-OpenSansRegular text-[14px] font-[700] text-subTitleColor">back</span>
        </div>
      </div>
      <div className="w-full border-solid border-[1px] border-borderColor">
        <div className="w-full h-[30px]  flex items-center px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Customer Information</span>
        </div>
        <div className="w-full min-h-[80px] flex items-center justify-center border-t-[1px] border-borderColor">
          <table className="w-full table-fixed">
            <thead>
              <tr className="border-b-[1px] border-borderColor">
                <th className="w-[230px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Customer/Location(s)
                  </div>
                </th>
                <th className="w-[170px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Contact Name
                  </div>
                </th>
                <th className="w-[180px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Contact Email
                  </div>
                </th>
                <th className="w-[140px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Contact Phone #
                  </div>
                </th>
                <th className="border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Address
                  </div>
                </th>
                <th className="w-[250px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Branch(s)
                  </div>
                </th>
                <th className="w-[120px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Added By
                  </div>
                </th>
                <th className="w-[120px] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    Date Added
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {customerLocations.length === 0 ? (
                <tr className="border-b-[1px] border-borderColor">
                  <td colSpan={8}>
                    <div className="font-OpenSansRegular px-[15px] py-[10px] text-[12px] font-[400] text-subTitleColor">
                      No customer locations have been added to this customer yet.
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {selectedAccount && (
                    <tr className="border-b-[1px] border-borderColor h-[40px] bg-white">
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[600] flex items-center justify-between gap-4 word-break-break-word text-titleColor">
                          <span>{selectedAccount.name}</span>
                          <span className="text-titleColor whitespace-nowrap">{customerLocations.length}</span>
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor"></td>
                      <td className="border-r-[1px] border-borderColor"></td>
                      <td className="border-r-[1px] border-borderColor"></td>
                      <td className="border-r-[1px] border-borderColor"></td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] text-titleColor">
                          {getBranchSummary(customerLocations)}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor"></td>
                      <td className="border-r-[1px] border-borderColor"></td>
                    </tr>
                  )}
                  {customerLocations.map((customerLocation) => (
                    <tr
                      key={customerLocation.id}
                      className="border-b-[1px] border-borderColor bg-[#FCFCFC]"
                    >
                      <td className="border-r-[1px] border-borderColor">
                        <div
                          className={`font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor ${selectedAccount ? "pl-8" : ""}`}
                        >
                          {customerLocation.companyName || ""}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor">
                          {customerLocation.contact || ""}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor break-words">
                          {customerLocation.email || ""}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor">
                          {customerLocation.phone || ""}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor break-words">
                          {customerLocation.address || ""}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor">
                          {customerLocation.branch?.name || ""}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor">
                          {getAddedByLabel(customerLocation)}
                        </div>
                      </td>
                      <td className="border-r-[1px] border-borderColor">
                        <div className="font-OpenSansRegular px-[15px] py-[8px] text-[11px] font-[400] text-titleColor">
                          {customerLocation.createdAt
                            ? formatDate(customerLocation.createdAt, "MM/DD/YYYY")
                            : ""}
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor  mt-3">
        <div className="w-full h-[40px]  flex items-center px-3 justify-between">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Customer App Users</span>
          <BlueButton
            title="ADD CUSTOMER ADMIN"
            onClicked={() => {
              console.log("customer: ", customer);
              if (!customer.branch) {
                toast.error("Please select a branch for this customer first");
                return;
              }
              setIsAddCustomerAdminModalOpen(true);
            }}
          />
        </div>
        <div className="w-full min-h-[80px] flex items-center justify-center">
          <table className="w-full">
            <thead>
              <tr className="border-t-[1px] border-b-[1px] border-borderColor">
                <th className="border-r-[1px] border-borderColor w-[30%]">
                  <div className="font-OpenSansRegular  font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    <span>Email</span>
                  </div>
                </th>
                <th className="border-r-[1px] border-borderColor w-[20%]">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                    Role
                  </div>
                </th>
                <th className="border-r-[1px] border-borderColor w-[25%]">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                    Status
                  </div>
                </th>
                <th className="w-[25%] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-2 h-[40px] text-titleColor">
                    InvitedAt
                  </div>
                </th>
                <th className="w-[100px]">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-2 h-[40px] text-titleColor">
                    ACTION
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {invites.map((invite, i) => (
                <tr key={i} className="border-b-[1px] border-borderColor h-[40px]">
                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {invite.email}
                    </div>
                  </td>
                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {invite.customerRole.name}
                    </div>
                  </td>

                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {invite.accepted ? <AcceptStatus /> : <PendingStatus />}
                    </div>
                  </td>
                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {formatDate(invite.createdAt)}
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center gap-1 justify-center">
                      <img
                        onClick={() => onCancelClicked(i)}
                        src={getImageUrl("/images/customerdetail/trash.png")}
                        className="w-[17px] h-[17px] cursor-pointer"
                      />
                      {/* <img
                        onClick={() => onRepeatClicked(i)}
                        src={getImageUrl("/images/customerdetail/repeat.png")}
                        className="w-[22px] h-[22px] cursor-pointer"
                      /> */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor  mt-3">
        <div className="w-full min-h-[80px] flex items-center justify-center ">
          <CustomerWO customerLocations={customerLocations} />
        </div>
      </div>
    </div>
  );
};

export default CustomerDetail;
